import React, { useState } from 'react';
import cn from 'classnames';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import { ReactComponent as ArrowRight } from 'styles/icon/arrowRight.svg';
import strings from 'lang/lang';
import accordion from './FooterListMobile.scss';

import ContactLinks from './ContactLinks';
import SocialLinks from './SocialLinks';
import ProductsLinks from './ProductsLinks';
import ResourcesLinks from './ResourcesLinks';
import SolutionsLinks from './SolutionsLinks';
import PlatformLinks from './PlatformLinks';
import UseCasesLinks from './UseCasesLinks';

const FooterListMobile = () => {
  const [isOpenContacts, setContactAccordion] = useState(false);
  const [isOpenSocials, setSocialsAccordion] = useState(false);
  const [isOpenProducts, setProductsAccordion] = useState(false);
  const [isOpenResources, setResourcesAccordion] = useState(false);
  const [isOpenSolutions, setSolutionsAccordion] = useState(false);
  const [isOpenPlatforms, setPlatformsAccordion] = useState(false);
  const [isOpenUseCases, setUseCasesAccordion] = useState(false);

  return (
    <Accordion allowZeroExpanded allowMultipleExpanded className={accordion.accordion}>
      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setContactAccordion(!isOpenContacts)}
          className={cn({ accordion__open: isOpenContacts })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenContacts
            })}>
              <span>{strings.footerList.text.contact}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ContactLinks />
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setSocialsAccordion(!isOpenSocials)}
          className={cn({ accordion__open: isOpenSocials })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenSocials
            })}>
              <span>{strings.footerList.text.socialIcons}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <SocialLinks />
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setProductsAccordion(!isOpenProducts)}
          className={cn({ accordion__open: isOpenProducts })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenProducts
            })}>
              <span>{strings.footerList.text.productsTitle}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ProductsLinks />
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setResourcesAccordion(!isOpenResources)}
          className={cn({ accordion__open: isOpenResources })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenResources
            })}>
              <span>{strings.footerList.text.resources}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ResourcesLinks />
        </AccordionItemPanel>
      </AccordionItem>
      
      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setSolutionsAccordion(!isOpenSolutions)}
          className={cn({ accordion__open: isOpenSolutions })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenSolutions
            })}>
              <span>{strings.footerList.text.solutions}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <SolutionsLinks />
        </AccordionItemPanel>
      </AccordionItem>
      
      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setPlatformsAccordion(!isOpenPlatforms)}
          className={cn({ accordion__open: isOpenPlatforms })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenPlatforms
            })}>
              <span>{strings.footerList.text.platform}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <PlatformLinks />
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem>
        <AccordionItemHeading
          onClick={() => setUseCasesAccordion(!isOpenUseCases)}
          className={cn({ accordion__open: isOpenUseCases })}
        >
          <AccordionItemButton>
            <div className={cn("accordion__header", {
              'accordion__header--open': isOpenUseCases
            })}>
              <span>{strings.footerList.text.cases}</span>
              <ArrowRight />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <UseCasesLinks />
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default FooterListMobile;
